<script lang="ts">
  import { type Snippet } from "svelte";
  import WaitButton from "../WaitButton.svelte";
  import type { HTMLInputAttributes } from "svelte/elements";

  type Props = Omit<HTMLInputAttributes, "value" | "class" | "oninput" | "onfocus" | "onblur"> & {
    inputClass? : string;
    buttonClass? : string;
    clean? : boolean | string;
    value? : string;
    label? : string | Snippet;
    action : (s: string)=>any;
    validator? : (s: string)=>string;
  };

  let {
    inputClass = "",
    buttonClass = "",
    disabled,
    clean = undefined,
    value = $bindable(""),
    label = "Add",
    action,
    validator = (_v)=>"",
    ...rest
  } : Props = $props()

  let input = $state<HTMLInputElement>();
  let cleanMessage = $derived(clean === true ? `${label} or clear to continue` : (clean || ""));

  function blurValidity() {
    const msg = (clean && value) ? cleanMessage : "";
    input?.setCustomValidity(msg);
  }

  function disallowBlank(value: string) {
    if(!value.trim()) return "Please enter a value";
    return "";
  }

  function doAction(){
    const cv = validator(value) || disallowBlank(value)
    input?.setCustomValidity(cv)

    if(input && !input.checkValidity()) {
      input.reportValidity()
      return;
    }
    return action(value)
  }

  function onInputKeydown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.preventDefault();
      doAction();
    }
  }

  export function focus() { input?.focus() }
</script>
<fieldset class="join w-full">
  <label
    class="join-item w-3/4 input input-bordered border-r-0 focus-within:outline-none focus-within:border-blue-600
           flex items-center gap-2"
  >
    <input
      bind:this={input} bind:value
      oninput={(_e)=>input?.setCustomValidity("")}
      onblur={(_e)=>{ blurValidity() }}
      onkeydown={onInputKeydown}
      class="grow {inputClass}"
      {disabled}
      {...rest}
    >
  </label>
  <WaitButton type="button" class="btn {buttonClass} join-item w-1/4" onclick={doAction} {disabled}>
    {#if typeof label === "string"}
      {label}
    {:else}
      {@render label?.()}
    {/if}
  </WaitButton>
</fieldset>
